export default __webpack_public_path__ + "static/media/commerce.5d0f5ee0.png";